import React, { useEffect, useState } from 'react';

export default function App() {
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/message`)
      .then(res => res.json())
      .then(data => setMessage(data.text));
  }, []);

  return (
    <div style={{ padding: '20px', fontSize: '20px' }}>
      {message}
    </div>
  );
}
